(function () {
  var wrap = document.querySelector('[data-cw-mobile-floating-atc-wrap]');
  var floatingButton = document.querySelector('[data-cw-mobile-floating-atc]');
  var realButton = document.querySelector('[data-product-add-to-cart]');

  if (!wrap || !floatingButton) {
    return;
  }

  floatingButton.addEventListener('click', function () {
    if (realButton) {
      realButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  if (realButton && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
          wrap.setAttribute('data-cw-mobile-floating-atc-hidden', '');
        } else {
          wrap.removeAttribute('data-cw-mobile-floating-atc-hidden');
        }
      });
    });

    observer.observe(realButton);
  }

  document.addEventListener('variantChange', function (event) {
    var variant = event.detail && event.detail.variant;
    var available = !!(variant && variant.available);

    floatingButton.disabled = !available;
    floatingButton.textContent = available
      ? floatingButton.getAttribute('data-cw-mobile-floating-atc-text')
      : floatingButton.getAttribute('data-cw-mobile-floating-atc-sold-out-text');
  }, true);
})();
